// React
import { memo, useCallback } from "react";

// UI
import { CheckBox } from "ui/components/CheckBox";
import { TextField } from "ui/components/TextField/TextField";

// Lokalne komponente
import PricingStepIntro from "ui/modules/pricing/components/PricingStepIntro/PricingStepIntro";

// Tipovi
import { SchemeBasicsStepProps } from "./types";

/** Naziv, opis i je li se shema još nudi novim klijentima. */
const SchemeBasicsStep: React.FC<SchemeBasicsStepProps> = (props: SchemeBasicsStepProps) => {
  const { formValues, setFormValues, errors, scheme } = props;

  const handleNameChange = useCallback(
    (e: any) => {
      const value = e?.target?.value ?? null;

      setFormValues((previous) => ({ ...previous, name: value }));
    },
    [setFormValues]
  );

  const handleDescriptionChange = useCallback(
    (e: any) => {
      const value = e?.target?.value ?? null;

      setFormValues((previous) => ({ ...previous, description: value }));
    },
    [setFormValues]
  );

  const handleActiveChange = useCallback(() => {
    setFormValues((previous) => ({ ...previous, isActive: !previous.isActive }));
  }, [setFormValues]);

  return (
    <>
      <PricingStepIntro
        title={scheme ? "Uređivanje grupe" : "Nova cjenovna grupa"}
        description={
          <>
            Cjenovna grupa je imenovani skup promjena koji se dodjeljuje klijentu, pa se popust
            ne upisuje svakome posebno. Naziv se vidi na kartici klijenta, pa neka kaže{" "}
            <strong>kome je namijenjena</strong>.
          </>
        }
      />

      <div className="flex flex-col gap-4 p-4 w-full max-w-4xl mx-auto">
        <div>
          <TextField
            type="text"
            name="name"
            label="Naziv grupe"
            placeholder="npr. Preprodavač"
            value={formValues.name ?? ""}
            onChange={handleNameChange}
            error={errors.name}
            required
            width="full"
          />
        </div>

        <div>
          <TextField
            type="text"
            name="description"
            label="Opis"
            placeholder="Kratko, čemu grupa služi"
            value={formValues.description ?? ""}
            onChange={handleDescriptionChange}
            width="full"
          />
        </div>

        <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
          <CheckBox
            name="isActive"
            label="Aktivna, nudi se novim klijentima"
            checked={formValues.isActive}
            onChange={handleActiveChange}
          />

          <p className="text-sm text-slate-600 mt-3">
            Gašenjem se grupa prestaje nuditi novim klijentima. Klijenti koji su već u njoj
            ostaju i nastavljaju po istim cijenama, jer nitko ne poskupljuje bez odluke čovjeka.
          </p>

          {!formValues.isActive && scheme && scheme.tenantCount > 0 && (
            <p className="text-sm text-amber-700 mt-2">
              U ovoj grupi trenutno je {scheme.tenantCount} klijenata i oni u njoj ostaju.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default memo(SchemeBasicsStep);
